import { render, staticRenderFns } from "./DisabledLabelsWarning.vue?vue&type=template&id=84e3e442"
import script from "./DisabledLabelsWarning.vue?vue&type=script&lang=js"
export * from "./DisabledLabelsWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports